import type { AppAction } from "../redux/app.types"

//#region Paging
export type PagingOptions = {
  currentPage: number
  totalPages: number
  pageSize: number
}
export interface IStateWithPaging {
  pagingOptions: PagingOptions
}

export type PagingActions = PagingAction | PagingPageAction

export type PagingAction = AppAction<PagingOptions>
export type PagingPageAction = AppAction<number>
//#endregion

//#region Sorting

export type SortableTableHeaderCellProperty = {
  key: string
  label: string
  disableSort?: boolean
  enableFiltering?: boolean
}

export type SortOrder = "desc" | "asc"
//#endregion

export enum Opco {
  Noordhoff = 0,
  Plantyn = 1,
  Liber = 2
}

//#region Analytics

export enum AnalyticsPageCategory {
  ContentManager = "content-manager",
  Home = "home",
  Result = "result",
  Content = "content",
  ContentLibrary = "content-library",
  Unknown = "unknown"
}

export enum AnalyticsPageType {
  Theme = "theme",
  Region = "region",
  Chapter = "chapter",
  Map = "map",
  Project = "project",
  Comparison = "comparison",
  Licence = "licence",
  Content = "content",
  Asset = "asset",
  Overview = "overview",
  Error = "error"
}

export enum AnalyticsSearchModule {
  Widget = "widget",
  Main = "main",
  ContentManager = "content-manager",
  RegionFilterGroup = "region-filter-group",
  TypeFilterGroup = "type-filter-group",
  ThemeFilterGroup = "theme-filter-group",
  CategoryFilterGroup = "category-filter-group"
}

export enum AnalyticsElementModule {
  MapDrawingPane = "map-drawing-pane",
  MapDrawingColorPicker = "map-drawing-color-picker",
  MapActionsPanel = "map-actions-panel"
}

export enum SettingFlags {
  toggleContentManager = "toggleContentManager"
}

export enum FeatureFlags {
  feedback = "feedback"
}

//#endregion
